import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import { getAdminUsers, toggleUserBlock, deleteAdminUser } from '../api/adminApi';

function formatDate(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('fa-IR');
}

export const AdminUsersList = () => {
  const { token } = useAdminAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [blockTarget, setBlockTarget] = useState(null); // { user, newStatus }
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const loadUsers = async (searchTerm = search, pageNum = page) => {
    setLoading(true);
    const result = await getAdminUsers(token, pageNum, searchTerm);
    setLoading(false);

    if (result.success) {
      setUsers(result.data.users);
      setTotalPages(result.data.totalPages);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  useEffect(() => {
    loadUsers(search, page);
    // eslint-disable-next-line
  }, [page]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    loadUsers(search, 1);
  };

  const confirmToggleBlock = (user) => {
    setBlockTarget({ user, newStatus: !user.is_blocked });
  };

  const handleToggleBlock = async () => {
    if (!blockTarget) return;
    const { user, newStatus } = blockTarget;

    const result = await toggleUserBlock(token, user.id, newStatus);
    setBlockTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadUsers();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminUser(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadUsers();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <h2 className="w3-text-white" style={{ marginBottom: 20 }}>مدیریت کاربران</h2>

      {/* جستجو */}
      <form onSubmit={handleSearchSubmit} style={{ display: 'flex', gap: 10, marginBottom: 20, maxWidth: 400 }}>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="جستجو بر اساس نام کاربری یا شماره تماس..."
          className="w3-input"
          style={{
            border: '1px solid white',
            backgroundColor: '#263238',
            color: 'white',
            borderRadius: 8,
            height: 40,
            flex: 1
          }}
        />
        <button
          type="submit"
          className="w3-button"
          style={{ color: '#4FC3F7', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 8, height: 40 }}
        >
          <i className="material-icons" style={{ verticalAlign: 'middle' }}>search</i>
        </button>
      </form>

      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 10, overflowX: 'auto' }}>
        {loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : users.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>کاربری یافت نشد.</p>
        ) : (
          <table className="w3-table w3-text-white" style={{ width: '100%', minWidth: 700 }}>
            <thead>
  <tr style={{ borderBottom: '1px solid #37474F' }}>
    <th style={{ textAlign: 'right', padding: 10 }}>نام کاربری</th>
    <th style={{ textAlign: 'right', padding: 10 }}>شماره تماس</th>
    <th style={{ textAlign: 'right', padding: 10 }}>پلن فعال</th>
    <th style={{ textAlign: 'right', padding: 10 }}>تعداد دانلود</th>
    <th style={{ textAlign: 'right', padding: 10 }}>تاریخ ثبت‌نام</th>
    <th style={{ textAlign: 'right', padding: 10 }}>وضعیت</th>
    <th style={{ textAlign: 'left', padding: 10 }}>عملیات</th>
  </tr>
</thead>
<tbody>
  {users.map((u) => (
    <tr key={u.id} style={{ borderBottom: '1px solid #263238' }}>
      <td style={{ padding: 10 }}>
        {u.account_name}
        {!!u.is_admin && (
          <span
            className="w3-round"
            style={{ backgroundColor: '#2980b933', color: '#4FC3F7', fontSize: 10, padding: '2px 6px', marginRight: 6 }}
          >
            ادمین
          </span>
        )}
      </td>
      <td style={{ padding: 10 }}>{u.phone_number}</td>
      <td style={{ padding: 10 }}>
        {u.active_plan ? (
          <span style={{ color: '#15ff00', fontSize: 13 }}>
            {u.active_plan} (تا {formatDate(u.plan_end_date)})
          </span>
        ) : (
          <span className="w3-text-grey" style={{ fontSize: 13 }}>ندارد</span>
        )}
      </td>
      <td style={{ padding: 10 }}>
        <span
          className="w3-round"
          style={{
            backgroundColor: u.download_count > 0 ? '#4FC3F722' : 'transparent',
            color: u.download_count > 0 ? '#4FC3F7' : '#90A4AE',
            padding: '3px 10px',
            fontSize: 13,
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          <i className="material-icons" style={{ fontSize: 15, marginLeft: 4 }}>download</i>
          {new Intl.NumberFormat('fa-IR').format(u.download_count)}
        </span>
      </td>
      <td style={{ padding: 10 }}>{formatDate(u.created_at)}</td>
      <td style={{ padding: 10 }}>
        {u.is_blocked ? (
          <span style={{ color: '#ff0000', fontSize: 13, display: 'flex', alignItems: 'center' }}>
            <i className="material-icons" style={{ fontSize: 15, marginLeft: 3 }}>block</i>
            مسدود
          </span>
        ) : (
          <span style={{ color: '#15ff00', fontSize: 13, display: 'flex', alignItems: 'center' }}>
            <i className="material-icons" style={{ fontSize: 15, marginLeft: 3 }}>check_circle</i>
            فعال
          </span>
        )}
      </td>
      <td style={{ padding: 10, textAlign: 'left', whiteSpace: 'nowrap' }}>
        <button
          onClick={() => confirmToggleBlock(u)}
          className="w3-button"
          style={{ color: u.is_blocked ? '#15ff00' : '#ff9800' }}
          title={u.is_blocked ? 'رفع مسدودی' : 'مسدود کردن'}
        >
          <i className="material-icons">{u.is_blocked ? 'lock_open' : 'block'}</i>
        </button>
        <button onClick={() => setDeleteTarget(u)} className="w3-button" style={{ color: '#ff0000' }} title="حذف">
          <i className="material-icons">delete</i>
        </button>
      </td>
    </tr>
  ))}
</tbody>
          </table>
        )}
      </div>

      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 20 }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className="w3-button w3-round"
              style={{
                minWidth: 36,
                backgroundColor: p === page ? '#2980b9' : 'transparent',
                color: 'white',
                border: '1px solid #37474F'
              }}
            >
              {p}
            </button>
          ))}
        </div>
      )}

      {/* تایید مسدودسازی/رفع مسدودی */}
      {blockTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: blockTarget.newStatus ? '#ff000022' : '#15ff0022',
                borderBottom: `2px solid ${blockTarget.newStatus ? '#ff0000' : '#15ff00'}`
              }}
            >
              <h4 className="w3-text-white" style={{ margin: 0 }}>
                {blockTarget.newStatus ? 'تایید مسدودسازی' : 'تایید رفع مسدودی'}
              </h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">
                آیا از {blockTarget.newStatus ? 'مسدود کردن' : 'رفع مسدودیت'} کاربر «{blockTarget.user.account_name}» مطمئن هستید؟
              </p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button
                onClick={handleToggleBlock}
                className="w3-button"
                style={{ flex: 1, color: 'white', backgroundColor: blockTarget.newStatus ? '#ff0000' : '#2e7d32', borderRadius: 10 }}
              >
                بله، مطمئنم
              </button>
              <button
                onClick={() => setBlockTarget(null)}
                className="w3-button"
                style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* تایید حذف */}
      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 360, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف کاربر</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">
                آیا از حذف کامل کاربر «{deleteTarget.account_name}» مطمئن هستید؟ این عمل غیرقابل بازگشت است و تمام سوابق خرید و عضویت او نیز حذف خواهد شد.
              </p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button
                onClick={() => setDeleteTarget(null)}
                className="w3-button"
                style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* پیام موفقیت/خطا */}
      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022',
                borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`
              }}
            >
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={() => setToast({ ...toast, show: false })}
                className="w3-button w3-block"
                style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};